import { useEffect, useState } from 'react';

const EMPTY = {
  nombre: '',
  descripcion: '',
  esSistema: false,
};

export default function Modal({ open, mode = 'new', data = null, onClose, onSubmit, inline = false }) {
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState({
    nombre: '',
    descripcion: '',
  });

  const validateField = (field, rawValue) => {
    const value = typeof rawValue === 'string' ? rawValue.trim() : rawValue;
    let error = '';

    switch (field) {
      case 'nombre':
        if (!value) error = 'El nombre del rol es obligatorio.';
        break;
      case 'descripcion':
        if (!value) error = 'La descripción es obligatoria.';
        break;
      default:
        break;
    }

    setErrors((prev) => ({ ...prev, [field]: error }));
    return !error;
  };

  const validateAll = () => {
    const fields = ['nombre', 'descripcion'];
    let isValid = true;
    fields.forEach(f => {
      if (!validateField(f, form[f])) isValid = false;
    });
    return isValid;
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    validateField(field, value);
  };

  useEffect(() => {
    if (mode === 'edit' && data) {
      const filled = {
        nombre: data.nombre ?? '',
        descripcion: data.descripcion ?? '',
        esSistema: !!data.esSistema,
      };
      setForm(filled);
      validateField('nombre', filled.nombre);
      validateField('descripcion', filled.descripcion);
    } else {
      setForm(EMPTY);
      setErrors({ nombre: '', descripcion: '' });
    }
  }, [mode, data]);

  if (!open) return null;

  const hasErrors = Object.values(errors).some((e) => !!e);
  const isSaveDisabled = !form.nombre?.trim() || !form.descripcion?.trim() || hasErrors;

  const errorStyle = {
    color: '#b91c1c',
    fontSize: '.8rem',
    display: 'block',
    marginTop: '4px',
  };

  const Header = (
    <div
      className="roles-topbar"
      style={{
        marginBottom: '0.6rem',
        paddingRight: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: '0 0 auto',
      }}>
      <h3 className="roles-title" style={{ marginRight: 0 }}>{mode === 'new' ? 'Nuevo rol' : 'Editar rol'}</h3>
      <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
    </div>
  );

  const Body = (
    <div
      style={{
        paddingLeft: '15%',
        paddingRight: 16,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0.8rem',
        overflowY: 'auto',
        flex: '1 1 auto',
        minHeight: 0,
      }}>
      <div style={{ gridColumn: '1 / -1' }}>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Nombre del rol:</label>
        <br /><br />
        <input
          className={`infoField${errors.nombre ? ' infoField--error' : ''}`}
          value={form.nombre}
          onChange={(e) => handleChange('nombre', e.target.value)}
          maxLength={100} />
        {errors.nombre && <small style={errorStyle}>{errors.nombre}</small>}
      </div>

      <div style={{ gridColumn: '1 / -1' }}>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Descripción:</label>
        <br /><br />
        <textarea
          className={`infoField${errors.descripcion ? ' infoField--error' : ''}`}
          style={{ minHeight: 100, resize: 'vertical' }}
          value={form.descripcion}
          onChange={(e) => handleChange('descripcion', e.target.value)}
          maxLength={500} />
        {errors.descripcion && <small style={errorStyle}>{errors.descripcion}</small>}
      </div>
    </div>
  );

  const Footer = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '.6rem',
        marginTop: '.8rem',
        paddingRight: 16,
        flex: '0 0 auto',
      }}
    >
      <button className="btn-cancel" onClick={onClose}>Cancelar</button>
      <button
        className="btn-action"
        onClick={() => {
          if (validateAll()) onSubmit(form, mode);
        }}
        disabled={isSaveDisabled}
        style={{
          opacity: isSaveDisabled ? 0.5 : 1,
          cursor: isSaveDisabled ? 'not-allowed' : 'pointer',
        }}
      >
        {mode === 'new' ? 'Guardar' : 'Actualizar'}
      </button>
    </div>
  );

  if (inline) {
    return (
      <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        {Header}
        {Body}
        {Footer}
      </div>
    );
  }

  return (
    <div
      className="roles-confirm-overlay"
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        zIndex: 1000,
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}>
      <div
        className="roles-confirm-card"
        style={{
          width: 'min(720px, 96vw)',
          maxHeight: '85vh',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,.25)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {Header}
        {Body}
        {Footer}
      </div>
    </div>
  );
}
